// extracted by mini-css-extract-plugin
module.exports = {"text-input-error":"MoneyMask_text-input-error__2UIIv","text-input-success":"MoneyMask_text-input-success__4xwWp"};